<template>
  <div class="workStationPage">
    <div class="leftContent">
      <p class="title">
        <span>生产线</span>
        <!-- <i class="el-icon-circle-plus-outline"></i> -->
      </p>
      <el-tree
        ref="tree"
        :data="factoryProductionLineData"
        :props="defaultProps"
        @node-click="handleNodeClick"
        highlight-current
        node-key="id"
        :expand-on-click-node="true"
      >
        <!-- :default-expanded-keys="[]" -->
        <!-- <span class="custom-tree-node" slot-scope="{ node }">
          <span :title="node.label">{{ node.label }}</span>
        </span> -->
      </el-tree>
    </div>
    <div class="rightContent">
      <el-table
        stripe
        :data="workStationData"
        border
        style="width: 100%"
        height="100%"
        size="mini"
        @sort-change="sortChange"
      >
        <el-table-column
          type="index"
          :width="pagination.endIndex >= 1000 ? 80 : 50"
          align="center"
          :index="pagination.beginIndex"
        ></el-table-column>
        <el-table-column prop="id" label="ID"
          align="center" min-width="110" show-overflow-tooltip sortable="custom"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.id">{{ scope.row.id }}</span>
            <span class="textWarning" v-else>否</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="工序"
          align="center"
          min-width="110"
          show-overflow-tooltip
          sortable="custom"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.name">{{ scope.row.name }}</span>
            <span class="textWarning" v-else>否</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="typeId"
          label="生产线"
          align="center"
          min-width="90"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span v-if="scope.row.type">{{ scope.row.type.name }}</span>
            <span class="textWarning" v-else>否</span>
          </template>
        </el-table-column>
        <el-table-column prop="workStation" label="重复执行" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="textSuccess" v-if="scope.row.sameRedo">允许</span>
            <span class="textWarning" v-else>不允许</span>
          </template>
        </el-table-column>
        <el-table-column prop="alwaysRedo" label="跳回执行" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="textSuccess" v-if="scope.row.alwaysRedo">允许</span>
            <span class="textWarning" v-else>不允许</span>
          </template>
        </el-table-column>
        <el-table-column prop="ims" label="IMS工序" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="textSuccess" v-if="scope.row.ims">是</span>
            <span class="textWarning" v-else>否</span>
          </template>
        </el-table-column>
        <el-table-column prop="uploadLog" label="上传日志" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="textSuccess" v-if="scope.row.uploadLog">是</span>
            <span class="textWarning" v-else>否</span>
          </template>
        </el-table-column>
        <el-table-column prop="bestOfSupper" label="支持局胜制" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="textSuccess" v-if="scope.row.bestOfSupper">是</span>
            <span class="textWarning" v-else>否</span>
          </template>
        </el-table-column>
        <el-table-column
          class-name="operation"
          label="操作"
          align="center"
          width="95px"
        >
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              content="修改"
              placement="top"
              :open-delay="300"
            >
              <i
                @click="editDeveloper($event, scope.row)"
                class="el-icon-edit"
              ></i>
            </el-tooltip>
            <el-tooltip
              v-if="scope.row.enable"
              class="item"
              effect="dark"
              content="禁用"
              placement="top"
              :open-delay="300"
            >
              <i
                @click="disableDeveloper($event, scope.row)"
                class="iconfont icon-jinyong"
              ></i>
            </el-tooltip>
            <el-tooltip
              v-else
              class="item"
              effect="dark"
              content="启用"
              placement="top"
              :open-delay="300"
            >
              <i
                @click="enableDeveloper($event, scope.row)"
                class="iconfont icon-qiyong"
              ></i>
            </el-tooltip>
            <el-tooltip
              v-if="currentNodeKey"
              class="item"
              effect="dark"
              content="上移"
              placement="top"
              :open-delay="300"
            >
              <i
                @click="moveUpDeveloper($event, scope.row)"
                class="el-icon-arrow-up"
              ></i>
            </el-tooltip>
            <el-tooltip
              v-if="currentNodeKey"
              class="item"
              effect="dark"
              content="下移"
              placement="top"
              :open-delay="300"
            >
              <i
                @click="moveDownDeveloper($event, scope.row)"
                class="el-icon-arrow-down"
              ></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :pagination="pagination"
        @currentChange="currentChange"
        @sizeChange="sizeChange"
        @refreshBtn="getFactoryWorkStationSearch"
      ></pagination>
    </div>
    <myDialog
      ref="workStationDialog"
      :title="workStationDialogTitle"
      @submitData="submitData"
      @dialogClose="dialogClose"
      width="450px"
    >
      <template slot="content">
        <div class="tips" v-show="workStationDialogTitle == '修改工序'">
          <span class="title">温馨提示：</span>修改后在新工单生效，已有工单在工单工序中修改。
        </div>
        <el-form
          ref="workStationDialogForm"
          :model="workStationDialogForm"
          :rules="workStationDialogRules"
          :label-width="labelWidth"
        >
          <el-form-item label="工序名称" size="small" prop="name">
            <el-input
              v-model="workStationDialogForm.name"
              placeholder="输入工序名称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="生产线" size="small" prop="typeId">
            <el-select
              v-model="workStationDialogForm.typeId"
              placeholder="选择生产线类别"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in pullDownData.ProductionLineTypeList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="标签类型" size="small" prop="labelType">
            <el-select
              v-model="workStationDialogForm.labelType"
              placeholder="选择标签类型"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in $parent.pullDownData.labelTypeList"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <div class="myCheckBox">
            <el-checkbox v-model="workStationDialogForm.sameRedo">相同工序重复执行</el-checkbox>
            <el-checkbox v-model="workStationDialogForm.alwaysRedo">线体内跳回执行</el-checkbox>
              <el-checkbox v-model="workStationDialogForm.ims" style="width: 136px;">IMS工序</el-checkbox>
              <el-checkbox v-model="workStationDialogForm.uploadLog">上传日志</el-checkbox>
              <el-checkbox v-model="workStationDialogForm.bestOfSupper">支持局胜制</el-checkbox>
          </div>
          <el-form-item label="工序参数：" size="small" prop="options">
              <el-input
                v-model="workStationDialogForm.options"
                type="textarea"
                :autosize="{minRows: 10, maxRows: 14}"
                placeholder="参数配置"
              ></el-input>
          </el-form-item>
        </el-form>
      </template>
    </myDialog>
  </div>
</template>

<script>
import pagination from "@/components/pagination.vue";
import myDialog from "@/components/myDialog.vue";
import {
  apiFactoryProductionLine,
  apiFactoryWorkStationSearch,
  apiFactoryWorkStationAdd,
  apiFactoryWorkStationUpdate,
  apiFactoryWorkStationEnable,
  apiFactoryWorkStationMoveDisable,
  apiFactoryWorkStationMoveUp,
  apiFactoryWorkStationMoveDown,
} from "@/api/plantSetting.js";
export default {
  components: {
    pagination,
    myDialog,
  },
  props: {
    workStationSearchForm: {
      type: Object,
    },
  },
  data() {
    return {
      // tree配置
      defaultProps: {
        children: "children",
        label: "name",
      },
      currentNodeKey: undefined,
      factoryProductionLineData: [],
      pullDownData: {
        ProductionLineTypeList: [],
      },
      workStationData: [],
      desc: undefined,
      orderBy: [],
      pagination: {
        currentPage: 1,
        pageSize: 40,
        total: 102,
        beginIndex: 1,
        endIndex: 10,
      },
      workStationDialogTitle: "",
      workStationDialogForm: {
        sameRedo: false,
        alwaysRedo: false,
        ims: false,
        uploadLog: false,
        bestOfSupper: false,
      },
      workStationDialogRules: {
        name: [
          { required: true, message: "工序名称不能为空！", trigger: "blur" },
          {
            min: 2,
            max: 64,
            message: "长度在 2 到 64 个字符",
            trigger: "change",
          },
        ],
        typeId: [
          { required: true, message: "产线类别不能为空！", trigger: "blur" },
        ],
      },
      labelWidth: this.$store.state.labelWidth,
    };
  },
  watch: {
    // 监听tree节点
    currentNodeKey: function (newVal) {
      this.$parent.currentNodeKey = newVal;
      this.pagination.currentPage = 1;
      this.getFactoryWorkStationSearch();
    },
  },
  methods: {
    // 生产线数据
    async getFactoryProductionLineData() {
      const res = await apiFactoryProductionLine({
        all: true
      });
      if (res.code == 0) {
        this.factoryProductionLineData = JSON.parse(JSON.stringify(res.data));
        this.factoryProductionLineData.unshift({
          id: "",
          name: "全部",
        });
        this.pullDownData.ProductionLineTypeList = res.data;
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(this.currentNodeKey);
        });
      }
    },
    // tree点击
    handleNodeClick(data) {
      this.currentNodeKey = data.id;
    },
    // 表格数据
    async getFactoryWorkStationSearch(remove, callback) {
      if (!(remove == "noRemove")) {
        this.workStationData = [];
      }
      const res = await apiFactoryWorkStationSearch({
        ...this.workStationSearchForm,
        typeId: this.currentNodeKey,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        desc: this.desc,
        orderBy: this.orderBy,
      });
      // console.log(res);
      if (res.code == 0) {
        this.workStationData = res.data;
        this.pagination.total = res.total;
        this.pagination.beginIndex = res.beginIndex;
        this.pagination.endIndex = res.endIndex;
        if (callback) callback();
      }
    },
    // 新建工序
    addNewBtn() {
      this.workStationDialogTitle = "添加工序";
      this.$refs.workStationDialog.dialogVisible = true;
      this.$set(this.workStationDialogForm, "typeId", this.currentNodeKey);
      this.$set(this.workStationDialogForm, "options", "[]");
    },
    // 修改工序
    editDeveloper(e, row) {
      this.workStationDialogTitle = "修改工序";
      this.$refs.workStationDialog.dialogVisible = true;
      this.workStationDialogForm = {
        id: row.id,
        name: row.name,
        typeId: row.type?row.type.id: '',
        labelType: row.labelType,
        sameRedo: row.sameRedo,
        alwaysRedo: row.alwaysRedo,
        ims: row.ims,
        uploadLog: row.uploadLog,
        bestOfSupper: row.bestOfSupper,
        options: row.workStationOptions?JSON.stringify(row.workStationOptions, null, "\t"): "[]",
      };
    },
    // 对话框提交
    submitData(title) {
      this.$refs.workStationDialogForm.validate(async (valid) => {
        if (valid) {
          try {
            JSON.parse(this.workStationDialogForm.options)
          } catch {
            this.$message({
              message: "工序参数格式错误",
              type: "error",
            });
          }
          let res = {};
          if (title == "添加工序") {
            res = await apiFactoryWorkStationAdd({
              ...this.workStationDialogForm,
              options: JSON.parse(this.workStationDialogForm.options),
            });
            if (res.code == 0) {
              this.$refs.workStationDialog.dialogVisible = false;
              this.pagination.currentPage = 1;
              this.getFactoryWorkStationSearch();
              this.$message({
                message: "添加成功",
                type: "success",
              });
            }
          } else if (title == "修改工序") {
            res = await apiFactoryWorkStationUpdate({
              ...this.workStationDialogForm,
              options: JSON.parse(this.workStationDialogForm.options),
            });
            if (res.code == 0) {
              this.$refs.workStationDialog.dialogVisible = false;
              this.getFactoryWorkStationSearch("noRemove");
              this.$message({
                message: "修改成功",
                type: "success",
              });
            }
          }
        } else {
          return false;
        }
      });
    },
    // 关闭对话框
    dialogClose() {
      this.$refs.workStationDialogForm.resetFields();
      this.workStationDialogForm = {
        sameRedo: false,
        alwaysRedo: false,
        ims: false,
        uploadLog: false,
        bestOfSupper: false,
      };
    },
    // 表格数据排序
    sortChange({ prop, order }) {
      this.orderBy[0] = prop;
      if (order == "ascending") {
        this.desc = false;
      } else if (order == "descending") {
        this.desc = true;
      } else {
        this.desc = undefined;
        this.orderBy = [];
      }
      this.getFactoryWorkStationSearch();
    },
    // 页码改变
    currentChange(val) {
      this.pagination.currentPage = val;
      this.getFactoryWorkStationSearch();
    },
    // 页容量改变
    sizeChange(val) {
      this.pagination.currentPage = 1;
      this.pagination.pageSize = val;
      this.getFactoryWorkStationSearch();
    },
    // 禁用
    disableDeveloper(e, row) {
      e.target.blur();
      this.$allOperation(row, "禁用", "工序").then(async () => {
        const res = await apiFactoryWorkStationMoveDisable({
          id: row.id,
        });
        // console.log(res)
        if (res.code == 0) {
          this.getFactoryWorkStationSearch("noRemove");
          this.$message({
            message: "禁用成功",
            type: "success",
          });
        }
      });
    },
    // 启用
    enableDeveloper(e, row) {
      e.target.blur();
      this.$allOperation(row, "启用", "工序").then(async () => {
        const res = await apiFactoryWorkStationEnable({
          id: row.id,
        });
        // console.log(res)
        if (res.code == 0) {
          this.getFactoryWorkStationSearch("noRemove");
          this.$message({
            message: "启用成功",
            type: "success",
          });
        }
      });
    },
    // 上移
    moveUpDeveloper(e, row) {
      e.target.blur();
      this.$confirm(`是否上移【${row.name}】？`, "上移工序", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const res = await apiFactoryWorkStationMoveUp({
          id: row.id,
        });
        // console.log(res)
        if (res.code == 0) {
          this.getFactoryWorkStationSearch("noRemove");
          this.$message({
            message: "上移成功",
            type: "success",
          });
        }
      });
    },
    // 下移
    moveDownDeveloper(e, row) {
      e.target.blur();
      this.$confirm(`是否下移【${row.name}】？`, "下移工序", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const res = await apiFactoryWorkStationMoveDown({
          id: row.id,
        });
        // console.log(res)
        if (res.code == 0) {
          this.getFactoryWorkStationSearch("noRemove");
          this.$message({
            message: "下移成功",
            type: "success",
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.workStationPage {
  width: 100%;
  height: 100%;
  display: flex;
  .myCheckBox {
    line-height: 33px;
    margin-bottom: 16px;
    padding-left: 52px;
  }
}
</style>